/* ============
 * Bill Type Transformer
 * ============
 *
 * The transformer for the billTypes.
 */

import Transformer from './transformer';

export default class contactTypeTransformer extends Transformer {

  static fetch(contactType) {
    return {
      id: contactType.id,
      name: contactType.name,
    };
  }

  static send(contactType) {
    return {
      id: contactType.id,
      name: contactType.name,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/contactType.js